import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';
import { Models } from '../../models/global.models';
import { SourceInformationLeadStore } from './source-information-lead.store';

@Injectable({ providedIn: 'root' })
export class SourceInformationLeadQuery extends Query<Models.SourceInformationLeadForm> {
  protected store: SourceInformationLeadStore;

  dirtyCheck = new DirtyCheckPlugin(this);

  constructor() {
    const store = inject(SourceInformationLeadStore);

    super(store);

    this.store = store;
  }
}
